export class Loan {

    Id  : number;
    ApplicationNo  : number;
    CustomerId  : number;
    ApplicationDate  : Date;
    CustomerName: string;
    CustomerAddress: string;
    Schemename: string;
    Centername: string;
    LoanTypeId  : number;
    SchemeId  : number;
    MinValue  : number;
    MaxValue  : number;
    IRRInterest  : number;
    FlatInterest  : number;
    InterestType : string;
    LoanAmount  : number;
    InterestAmount  : number;
    Category : string;
    LoanPurposeId  : number;
    IsJoint  : number;
    JointLoanee : string;
    Remarks : string;
    AgentId  : number;
    LoanApprovedStatusId  : number;
    DDFund  : number;
    LoanApprovedBy  : number;
    LoanApprovedDate  : Date;
    EmployeeId  : number;
    EmployeeBranchId  : number;
    CompanyId  : number;
    SaasId  : number;
    CreatedDate  : Date;
    ModifiedDate  : Date;
    IsActive : boolean;
    Flag: Number;
    IsCustomerSearch : boolean;
    IsApprovalClick : boolean;
    SearchByApprovedStatus : number;
    Recommendation: string;
    ApprovedRemarks: string;
    PreSavingsAmount: number;

    // for Report
    ReportName: string;
    FromDate: Date;
    ToDate : Date;
    BranchId: Number;
    CentreId: Number;
    loanCategoryId: Number;

    IsLoanPreclosure : boolean;

    IsCentreORCustomerWise: Number;

    PaymentTypeId: Number = 0;
    PaymentBankId: Number = 0;
    IsOpening : false;
    IsRejoin : false;
    LoanPreApprovedDate: Date;
}
